/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Recovery_PctInputs */

const en_us2_recovery_pct = /** @type {(inputs: Recovery_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const pt_br2_recovery_pct = /** @type {(inputs: Recovery_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const es_419_recovery_pct = /** @type {(inputs: Recovery_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const pt_pt2_recovery_pct = /** @type {(inputs: Recovery_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

const fr_fr2_recovery_pct = /** @type {(inputs: Recovery_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} %`)
};

const de_de2_recovery_pct = /** @type {(inputs: Recovery_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} %`)
};

const it_it2_recovery_pct = /** @type {(inputs: Recovery_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}%`)
};

/**
* | output |
* | --- |
* | "{pct}%" |
*
* @param {Recovery_PctInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_pct = /** @type {((inputs: Recovery_PctInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_PctInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_pct(inputs)
	if (locale === "es-419") return es_419_recovery_pct(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_pct(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_pct(inputs)
	if (locale === "de-DE") return de_de2_recovery_pct(inputs)
	if (locale === "it-IT") return it_it2_recovery_pct(inputs)
	return en_us2_recovery_pct(inputs)
});
export { recovery_pct as "recovery.pct" }